import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../site/Reveal";
import { scrollToId } from "../site/SmoothScroll";
import { Eyebrow } from "./Intro";

export const PhotoBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="photo-banner" className="relative overflow-hidden bg-[var(--forest)]">
      <motion.img style={{ y }} src="/images/w-pasture.jpg" alt="Dairy cattle grazing on farm pasture" className="absolute inset-0 h-[124%] -top-[12%] w-full object-cover" />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(0,40,26,0.9)_0%,rgba(0,40,26,0.6)_55%,rgba(0,40,26,0.25)_100%)]" />
      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-40">
        <Eyebrow light>Intake drives performance</Eyebrow>
        <Reveal as="h2" className="font-display text-white text-3xl sm:text-5xl lg:text-6xl leading-[1.05] mt-6 max-w-3xl">
          Every kilogram eaten becomes milk, growth and colour.
        </Reveal>
        <Reveal as="p" delay={0.1} className="mt-6 text-[#DCEBE0] text-base md:text-lg max-w-xl leading-relaxed">
          Ration changes, heat and bitter ingredients quietly cut intake. Our technical team helps you pick the right flavour, attractant or performance additive — and the right dose.
        </Reveal>
        <div className="mt-9 flex flex-col sm:flex-row gap-3">
          <Link to="/contact" data-testid="banner-expert-button" className="group inline-flex justify-center items-center gap-2 bg-[var(--lime)] text-[var(--forest)] px-7 py-4 rounded-md font-bold">
            Talk to an expert <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </Link>
          <button onClick={() => scrollToId("downloads")} data-testid="banner-brochures-button" className="inline-flex justify-center items-center border-2 border-white/80 text-white px-7 py-4 rounded-md font-bold hover:bg-white hover:text-[var(--forest)] transition-colors">
            Download brochures
          </button>
        </div>
      </div>
    </section>
  );
};
